module.exports = __webpack_public_path__ + "img/tff-teamtip.db5a62e2.png";